import React, { useState } from "react";
import { useFormContext } from "react-hook-form";

import { SendIcon } from "../../../../assets";
import { EMPTY_STRING } from "../../../../constants";
import HobbiesIconMapping from "../../../../assets/icons/HobbiesIconMapping";
import CustomSvg from "../../../../shared/components/custom-svg/CustomSvg";
import SurveyFormField from "../../../../shared/components/surveyFormField/SurveyFormField";

const HobbiesAndInterests = ({ allHobbies }) => {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();
  const selectedOptions = watch("hobbies") || []; // Watch the "hobbies" field

  const [searchValue, setSearchValue] = useState(EMPTY_STRING);

  const handleSelection = (option) => {
    if (selectedOptions.includes(option.id)) {
      // If the option is already selected, remove it
      setValue(
        "hobbies",
        selectedOptions.filter((selected) => selected !== option.id)
      );
    } else {
      // If the option is not selected, add it
      setValue("hobbies", [...selectedOptions, option.id]);
    }
  };

  const getFilteredHobbies = () => {
    const search = searchValue.trim();
    if (!search) {
      return allHobbies;
    } else {
      return allHobbies.filter((option) =>
        option.title.toLowerCase().includes(search.toLowerCase())
      );
    }
  };

  return (
    <div>
      <div className="question-heading">
        What are your hobbies and interests?
      </div>
      {errors.hobbies && <div className="error">{errors.hobbies.message}</div>}
      <div className="form-fields">
        <div className="w-85">
          <SurveyFormField
            placeHolder="type anything..."
            textValue={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            endAdornment={
              <div className="position-absolute send-icon-adornment">
                <img src={SendIcon} alt={EMPTY_STRING} />
              </div>
            }
          />
        </div>
        <div className="d-flex flex-wrap gap-2 gap-sm-4 rounded-options-container">
          {getFilteredHobbies().map((option, index) => (
            <div
              key={option.id}
              className={`px-2 rounded-options pointer ${
                selectedOptions.includes(option.id)
                  ? "rounded-option-selected"
                  : ""
              }`}
              onClick={() => handleSelection(option)}
            >
              <CustomSvg
                src={HobbiesIconMapping[option.icon]}
                className="d-flex pt-2 justify-content-center mx-auto hobbies-and-interest-icon"
                color="white"
              />

              <div className="text-center py-2 text-break">{option.title}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HobbiesAndInterests;
